import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import clamp from '../../util/clamp';
import { throttle } from '../../util/decorators';
import scrollToElement from '../../util/scrollToElement';
import pubSub from '../../util/pubSub';
import pageTracking from '../../util/pageTracking';
import googleAnalyticsTracking from '../../util/googleAnalyticsTracking';
import { appContext } from '../../util/decorators';
import Picture from '../Picture.jsx';

import getArticleLink from '../../util/getArticleLink';

const mapStateToProps = state => ({
  country: state.country,
});

@connect(mapStateToProps)
@appContext
export default class StoryNavItem extends React.PureComponent {
  static propTypes = {
    article: React.PropTypes.shape({
      id: React.PropTypes.string.isRequired,
      slug: React.PropTypes.string.isRequired,
      pictures: React.PropTypes.arrayOf(React.PropTypes.shape({
        data: React.PropTypes.shape({
          url: React.PropTypes.url,
        }),
      })),
      title: React.PropTypes.string,
      tags: React.PropTypes.object,
    }).isRequired,
    scrollTop: React.PropTypes.number.isRequired,
    windowSize: React.PropTypes.shape({
      width: React.PropTypes.number.isRequired,
      height: React.PropTypes.number.isRequired,
    }).isRequired,
    displayAdUpdate: React.PropTypes.shape({
      displayAdCount: React.PropTypes.number.isRequired,
    }).isRequired,
    index: React.PropTypes.number,
    dispatch: React.PropTypes.func,
    skipPathUpdate: React.PropTypes.bool,
    country: React.PropTypes.string,
  };

  constructor() {
    super();

    this.state = {
      progress: 0,
    };

    this.isCurrentArticle = false;
    this.speed = 500;
    this.movingFrequency = 15;

    this.trackArticle = _.once(this.trackArticle);
  }

  componentDidMount() {
    this.article = document.getElementById(`article-${this.props.article.id}`);
    this.articleCalculations(this.article);

    const storyNav = document.getElementById('story-nav');

    if (storyNav) {
      this.storyNavHeight = storyNav.clientHeight;
    }

    this.updateProgressBar(this.props.scrollTop, this.props.windowSize.height);
  }

  componentWillReceiveProps(nextProps) {
    const windowResized = this.props.windowSize.width !== nextProps.windowSize.width;
    const displayAdLoaded = nextProps.displayAdUpdate.displayAdCount !== this.props.displayAdUpdate.displayAdCount;
    const scrollTop = nextProps.scrollTop;

    if (displayAdLoaded || windowResized) {
      this.articleCalculations(this.article, scrollTop);
    }

    this.updateProgressBar(scrollTop, nextProps.windowSize.height);
    this.setCurrentArticle(scrollTop);
  }

  setCurrentArticle(scrollTop) {
    if (scrollTop >= this.articleOffset - (this.speed / this.movingFrequency) && scrollTop < this.articleOffset + this.articleHeight) {
      if (!this.isCurrentArticle) {
        if (!this.props.skipPathUpdate) window.history.replaceState('', this.props.article.title, this.props.article.slug);
        this.trackArticle();
        this.isCurrentArticle = true;
      }
    } else {
      this.isCurrentArticle = false;
    }
  }

  articleCalculations(article, scrollTop = this.props.scrollTop) {
    if (!article) return;

    this.articleHeight = article.clientHeight || 0;
    this.articleOffset = article.getBoundingClientRect().top + scrollTop;
  }

  updateProgressBar(scrollTop, windowHeight) {
    const progress = (scrollTop - this.articleOffset - this.storyNavHeight + windowHeight) / this.articleHeight * 100;

    this.setState({
      progress,
    });

    if (progress >= 0 && progress < 100) {
      this.publishAutoScrollEvent();
      this.publishShowMobileStoryNavVal(progress > 40 && this.articleHeight > 1500);
    }
  }

  clickHandler(evt) {
    scrollToElement(evt, this.article, this.props.scrollTop, this.speed, this.movingFrequency);
  }

  @throttle(300)
  publishAutoScrollEvent() {
    pubSub.publish('activeStoryNav', this.props.index);
  }

  @throttle(300)
  publishShowMobileStoryNavVal(showMobileStoryNav) {
    pubSub.publish('showMobileStoryNav', showMobileStoryNav);
  }

  trackArticle() {
    // First article is tracked by ordinary tracking.
    if (this.props.index !== 0) {
      pageTracking(this.props.country, true);
      googleAnalyticsTracking('event', {
        category: 'Content',
        label: 'Pageview from scroll',
      });
    }
  }

  render() {
    const { article } = this.props;
    const img = _.get(article, 'pictures[0].data.url') || _.get(article, 'videos[0].data.posterUrl');
    const hasVideo = _.includes(_.get(article, 'tags.contents', 'video'));
const articleUrl = getArticleLink(article, { href: true });

//{`${articleUrl}`} //onClick={(evt) => this.clickHandler(evt)}
    return (
      <div className="story-nav-item">
        <span className="progress-bar visible-sm-up" style={{ width: clamp(0, 100, this.state.progress) + '%' }}></span>
        <a
          href={article.slug}
          
          className={cx({ 'is-active': this.state.progress >= 0 && this.state.progress < 100 })}
        >
          <div className="story-nav-item-image visible-sm-up">
            <Picture src={img} alt={article.title} size={1}/>
            { hasVideo && <span className="icon-play"/> }
          </div>
          <div className="story-nav-item-content visible-sm-up">
            {article.title}
          </div>

          <div className="story-nav-item-content hidden-sm-up">
            <div className="icon-wrapper">
              <i className="icon-arrow-down"></i>
            </div>
            <div className="story-nav-item-text">
              <p className="heading">{this.context.app.t('StoryNav.next')}</p>
              <p className="title">{article.title}</p>
            </div>
          </div>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/StoryNavItem.jsx